import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function ContractApprovalStatusColumn({ value }: UseTableCellProps<CustomerContractInventoryGridItem>) {
  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{value}</Typography>
    </Box>
  );
}
